import { CreateFileInput } from "../../../Shared/dto/create-file-input";
import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreateUserInput } from "../models/CreateUserInput";

export class UserService {
  static async create(createUserInput: CreateUserInput) {
    return await HttpService.request({
      url: "/users/create",
      method: "POST",
      data: createUserInput,
    });
  }

  static async createFromFile(createFromFileInput: CreateFileInput) {
    return await HttpService.request({
      url: "/users/create/from-file",
      method: "POST",
      data: createFromFileInput,
    });
  }
  
  static async getById(id: string) {
    return await HttpService.request({
      url: `/users/find/${id}`,
      method: "GET",
    });
  }

  static async update(id: string, updateUserInput: CreateUserInput) {
    return await HttpService.request({
      url: `/users/${id}`,
      method: "PUT",
      data: updateUserInput,
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/users/${id}`,
      method: "DELETE",
    });
  }

  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/users/${JSON.stringify(ids)}`,
      method: "DELETE",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/users/find?${queryParams}`,
      method: "GET",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/users?findOptions=${query}`,
      method: "GET",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/users/search?query=${encodeURIComponent(query)}`,
      method: "GET",
    });
  }

  static async getProfile() {
    return await HttpService.request({
      url: "/users/profile",
      method: "GET",
    });
  }

  static async updateProfile(updateUserInput: CreateUserInput) {
    return await HttpService.request({
      url: "/users/profile",
      method: "PUT",
      data: updateUserInput,
    });
  }

  static async changePassword(oldPassword: string, newPassword: string) {
    const data = {
      oldPassword,
      newPassword,
    };
    return await HttpService.request({
      url: "/users/change-password",
      method: "POST",
      data,
    });
  }

  static async addRole(id: string, role: string) {
    return await HttpService.request({
      url: `/users/${id}/roles`,
      method: "POST",
      data: { role },
    });
  }

  static async removeRole(id: string, role: string) {
    return await HttpService.request({
      url: `/users/${id}/roles/${role}`,
      method: "DELETE",
    });
  }

  static async addPermissions(id: string, permissions: string[]) {
    return await HttpService.request({
      url: `/users/${id}/permissions`,
      method: "POST",
      data: { permissions },
    });
  }

  static async removePermissions(id: string, permissions: string[]) {
    return await HttpService.request({
      url: `/users/${id}/permissions`,
      method: "DELETE",
      data: { permissions },
    });
  }
}
